import { ComponentProps, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import type { FilterConfig } from '@alltrails/denali/components/FilterBar';
import Modal from '@alltrails/modal/components/Modal/Modal';
import styles from '../AllFiltersModal/FiltersModal/FiltersModal.module.scss';
import FilterControl from '../FilterControl/FilterControl';

type AdminFiltersModalProps = Pick<ComponentProps<typeof Modal>, 'isOpen' | 'onCloseRequest'> & {
  filterConfigs: FilterConfig[];
  onClear?: () => void;
  trailResultCount: number | null; // null indicates loading
};

const AdminFiltersModal = ({ onCloseRequest, isOpen, filterConfigs, onClear, trailResultCount }: AdminFiltersModalProps) => {
  return (
    <Modal
      buttons={{
        primaryButton: {
          loading: trailResultCount === null,
          onClick: onCloseRequest,
          text: (
            <FormattedMessage defaultMessage="Show {count} {count, plural, one {trail} other {trails}}" values={{ count: trailResultCount ?? 0 }} />
          )
        },
        ...(onClear
          ? {
              flatButton: {
                onClick: onClear,
                text: <FormattedMessage defaultMessage="Clear" />
              }
            }
          : {})
      }}
      isOpen={isOpen}
      onCloseRequest={onCloseRequest}
      title={<FormattedMessage defaultMessage="Admin" />}
    >
      <div className={styles.container}>
        {filterConfigs.map((filterConfig, index) => {
          const filterControl = <FilterControl filterConfig={filterConfig} />;
          return filterControl ? (
            <Fragment key={`filter-${index}`}>
              {filterControl}
              <div className={styles.divider} />
            </Fragment>
          ) : null;
        })}
      </div>
    </Modal>
  );
};

export default AdminFiltersModal;
